import React, { useContext, useRef, useState } from 'react';

import { Button, ButtonGroup, Collapse, NumericInput, Overlay, Popover } from '@blueprintjs/core';
import PageContext from '../../Context/PageContext';
import SketchColor from './SketchColor';
import { isDesktop, isMobile, isTablet, useMobileOrientation } from 'react-device-detect';
import { handleCloneAndCornerPosition } from '../../Util/ElemUtil';

import { Range } from 'react-range';

import $ from "jquery";
import { createOneValueElementAction } from '../../history/element.history';

const TextPicker = () => {

    const { objItems, selectedItem, zoomValue, history, getSelectedItem } = useContext(PageContext);

    const targetRef = useRef<HTMLInputElement>(null);
    const { isLandscape } = useMobileOrientation();

    const [openTextMobile, setOpenTextMobile] = useState(false);
    const [key, setKey] = useState(0);

    var value = 14; var defaultValue = 14;

    var item = objItems.find(item => item.id === selectedItem.id);

    const [itemFontSize, setItemFontSize] = useState(() => {
        var fontValue = item != null ? item.style["font-size"] : defaultValue;

        if (typeof fontValue === 'string') {
            fontValue = fontValue.replace("px", "");
        }

        return fontValue;
        //setItemFontSize(fontValue);
    });

    const [itemLetterSpace, setItemLetterSpace] = useState(item.style.letterSpace != null ? item.style.letterSpace : 0);
    const [itemColor, setItemColor] = useState(item.style.color != null ? item.style.color : 'white');

    function handleChange(event: number) {

        /* To set change property to listItems*/
        const item = objItems.find(item => item.id === selectedItem.id);

        if (selectedItem != null) {
            let from = item.style['font-size'];
            value = event;
            setItemFontSize(event);
            selectedItem.style.fontSize = event + 'px';
            item.style['font-size'] = event + 'px';

            //replace and size corner and move card          
            handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, zoomValue);

            let action = createOneValueElementAction({
                target: "font-size",
                item: item,
                from: from,
                to: item.style['font-size'],
                context: { zoomValue, getSelectedItem }
            });

            history.add(action);
        }
    }

    React.useEffect(() => {
        item = objItems.find(item => item.id === selectedItem.id);

        var fontValue = item != null ? item.style["font-size"] : defaultValue;

        if (typeof fontValue === 'string') {
            fontValue = fontValue.replace("px", "");
        }

        setItemFontSize(fontValue);
        setItemColor(item.style.color);

    }, [selectedItem])

    //history
    React.useEffect(() => {
        setItemLetterSpace(item.style.letterSpace)
    }, [item.style.letterSpace])

    /**/React.useEffect(() => {
        setItemColor(item.style.color);
    }, [item.style.color])



    function setTextFont(e: String) {
        /* To set changed property to listItems*/
        const item = objItems.find(item => item.id === selectedItem.id);

        let from = ''; let to = ''; let target = "font-weight";

        if (e == 'bold') {
            if (selectedItem != null) {
                target = "font-weight";

                if (selectedItem.style.fontWeight == 'bold') { selectedItem.style.fontWeight = 'normal'; item.style['font-weight'] = 'normal'; from = 'bold'; to = 'normal'; }
                else { selectedItem.style.fontWeight = 'bold'; item.style['font-weight'] = 'bold'; from = 'normal'; to = 'bold'; }
            }
        }
        else if (e == 'italic') {
            if (selectedItem != null) {
                target = "font-style";

                if (selectedItem.style.fontStyle == 'italic') { selectedItem.style.fontStyle = 'normal'; item.style['font-style'] = 'normal'; from = 'italic'; to = 'normal'; }
                else { selectedItem.style.fontStyle = 'italic'; item.style['font-style'] = 'italic'; from = 'normal'; to = 'italic'; }
            }
        }
        else if (e == 'underline') {
            if (selectedItem != null) {
                target = "text-decoration";

                if (selectedItem.style.textDecoration == 'underline') { selectedItem.style.textDecoration = 'none'; item.style['text-decoration'] = 'none'; from = 'underline'; to = 'none'; }
                else { selectedItem.style.textDecoration = 'underline'; item.style['text-decoration'] = 'underline'; from = 'none'; to = 'underline'; }
            }
        }
        else if (e == 'strikethrough') {
            if (selectedItem != null) {
                target = "text-decoration";

                if (selectedItem.style.textDecoration == 'line-through') { selectedItem.style['text-decoration'] = 'none'; item.style.textDecoration = 'none'; from = 'line-through'; to = 'none'; }
                else { selectedItem.style.textDecoration = 'line-through'; item.style['text-decoration'] = 'line-through'; from = 'none'; to = 'line-through'; }
            }
        }

        let action = createOneValueElementAction({
            target: target,
            item: item,
            from,
            to,
            context: {}
        });

        history.add(action);
    }

    function setAlign(e: String) {
        /* To set changed property to listItems*/
        const item = objItems.find(item => item.id === selectedItem.id);

        let from = item.style['text-align'];

        if (e == 'left') {
            if (selectedItem != null) { selectedItem.style.textAlign = 'left'; item.style['text-align'] = 'left'; }
        }
        else if (e == 'center') {
            if (selectedItem != null) { selectedItem.style.textAlign = 'center'; item.style['text-align'] = 'center'; }
        }
        else if (e == 'right') {
            if (selectedItem != null) { selectedItem.style.textAlign = 'right'; item.style['text-align'] = 'right'; }
        }
        else if (e == 'justify') {
            if (selectedItem != null) { selectedItem.style.textAlign = 'justify'; item.style['text-align'] = 'justify'; }
        }

        let action = createOneValueElementAction({
            target: "text-align",
            item: item,
            from,
            to: item.style['text-align'],
            context: {}
        });

        history.add(action);
    }

    function setRotate() {
        const item = objItems.find(item => item.id === selectedItem.id);
        if (!item || !selectedItem) return;

        //let from = item.style.transform;
        let from = extractRotateDeg(item.style.transform);

        //const currentRotate = selectedItem.rotate ?? 0;
        const currentRotate = item.rotate ?? 0;
        const nextRotate = (currentRotate + 90) % 360;

        //selectedItem.rotate = nextRotate;
        item.rotate = nextRotate;

        selectedItem.style.transform = `rotate(${nextRotate}deg)`;
        item.style.transform = `rotate(${nextRotate}deg)`;

        //replace and size corner and move card          
        handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, zoomValue);

        let action = createOneValueElementAction({
            target: "text-rotate",
            item: item,
            from,
            to: nextRotate,
            context: { zoomValue, getSelectedItem }
        });

        history.add(action);

    }

    function extractRotateDeg(transform: any) {
        const match = transform.match(/rotate\((-?\d+\.?\d*)deg\)/);
        return match ? Number(match[1]) : 0;
    }

    function letterSpacingChange(event: number) {

        var item = objItems.find(item => item.id === selectedItem.id);

        if (selectedItem != null) {

            let from = item.style.letterSpace;
            value = event;
            setItemLetterSpace(event);
            selectedItem.style.letterSpacing = event + 'px';
            item.style.letterSpace = event;

            //replace and size corner and move card          
            handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, zoomValue);


            let action = createOneValueElementAction({
                target: "letter-space",
                item: item,
                from,
                to: event,
                context: { zoomValue, getSelectedItem }
            });

            history.add(action);
        }
    }

    const elemText = () => {
        return (
            <div style={{ display: 'flex' }}>
                <div>
                    <div style={{ margin: '15px' }}>
                        <div className="">

                            <h3>Espace & Alignement</h3>
                            <div style={{ fontSize: 'small', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>Espace lettre
                                <div style={{}}>
                                    <NumericInput id="text-font-size"
                                        onValueChange={letterSpacingChange}
                                        value={itemLetterSpace}
                                        small={true} stepSize={1} />
                                </div>
                            </div>
                            <div style={{ width: '118px', marginTop: '10px' }}>

                                <ButtonGroup>
                                    <Button className='' onClick={() => setAlign('left')} icon="align-left" ></Button>
                                    <Button className='' onClick={() => setAlign('center')} icon="align-center"></Button>
                                    <Button className='' onClick={() => setAlign('right')} icon="align-right"></Button>
                                    <Button className='' onClick={() => setAlign('justify')} icon="align-justify"></Button>
                                </ButtonGroup>
                            </div>

                            <div style={{ width: '118px', marginTop: '10px' }}>

                                <ButtonGroup>
                                    <Button className='' onClick={() => setTextFont('bold')} icon="bold" ></Button>
                                    <Button className='' onClick={() => setTextFont('italic')} icon="italic"></Button>
                                    <Button className='' onClick={() => setTextFont('underline')} icon="underline"></Button>
                                    <Button className='' onClick={() => setTextFont('strikethrough')} icon="strikethrough"></Button>
                                </ButtonGroup>
                            </div>

                        </div>
                        <div>
                            <h3>Transformation</h3>
                            <Button className='' onClick={() => setRotate()} icon="rotate-cw" >Rotate</Button>
                        </div>


                    </div>
                </div>


            </div>
        )
    }

    return (
        <div className="text-picker">

            <SketchColor key={item.style.color} elem={'selectedItem'} /*color={item != null ? item.style.color : 'white'}*/ /**/ color={itemColor} />
            {(isDesktop || isTablet || (isMobile && isLandscape)) && <FontPicker item={item} key={item.style.color + 'unique'} />}
            {(isMobile && !isTablet) && !isLandscape && <FontPickerMobile item={item} key={item.style.color + 'unique'} />}


            {/*<input type="number" id="text-font-size" ref={targetRef} onChange={handleChange} defaultValue={defaultValue} />*/}
            <NumericInput id="text-font-size"
                onValueChange={handleChange}
                value={itemFontSize}
                small={true} stepSize={1} />

            {(isDesktop || isTablet || (isMobile && isLandscape)) &&
                <ButtonGroup>
                    <Button className='' onClick={() => setTextFont('bold')} icon="bold" ></Button>
                    <Button className='' onClick={() => setTextFont('italic')} icon="italic"></Button>
                    <Button className='' onClick={() => setTextFont('underline')} icon="underline"></Button>
                    <Button className='' onClick={() => setTextFont('strikethrough')} icon="strikethrough"></Button>
                </ButtonGroup>}

            {/*(isDesktop || isTablet)  && <ButtonGroup>
                <Button className='' onClick={() => setAlign('left')} icon="align-left" ></Button>
                <Button className='' onClick={() => setAlign('center')} icon="align-center"></Button>
                <Button className='' onClick={() => setAlign('right')} icon="align-right"></Button>
                <Button className='' onClick={() => setAlign('justify')} icon="align-justify"></Button>
            </ButtonGroup>*/}


            {/**/ <div>
                <Popover usePortal={false} content={elemText()} placement={(isMobile && !isTablet) ? "top-end" : "bottom-end"} onOpened={() => setKey(k => k + 1)}>
                    <Button className='' onClick={() => setOpenTextMobile(!openTextMobile)} disabled={selectedItem != null ? false : true} icon="more"></Button>
                </Popover>
            </div>}

        </div>
    );
};

function FontPicker(props: any) {

    const item = props.item;

    const { objItems, selectedItem, zoomValue, history, getSelectedItem } = useContext(PageContext);

    const fontArray = ["Abril Fatface",
        "Amatic SC",
        "Alfa Slab One",
        "Arial",
        "Arial Black",
        "Arimo",
        "Audiowide",
        "Bauhaus",
        "Baskerville",
        "Bebas Neue",
        "Bruno Ace",
        "Cabin Sketch",
        "Cinzel",
        "Comic Sans MS",
        "Courier",
        "Coolvetica",
        "Creepster",
        "DM Serif Text",
        "Edo",
        "Epilogue",
        "Exo",
        "Geist",
        "Georgia",
        "Gruppo",
        "Hachi Maru Pop",
        "Helvetica",
        "Homemade Apple",
        "IBM Plex Mono",
        "Impact",
        "Indie Flower",
        "Instrument Sans",
        "Kalnia",
        "Kodchasan",
        "Koulen",
        "Krona One",
        "Lexend Exa",
        "Limelight",
        "Londrina Shadow",
        "Michroma",
        "Monaco",
        "Monoton",
        "Montserrat",
        "Nothing You Could Do",
        "Open Sans",
        "Orbitron",
        "Oswald",
        "Outfit",
        "Palatino",
        "Patrick Hand SC",
        "Poiret One",
        "Poppins",
        "Questrial",
        "Raleway",
        "Reem Kufi",
        "Righteous",
        "Roboto",
        "Rubik Mono One",
        "Sanchez",
        "Shadows Into Light",
        "Sora",
        "Special Elite",
        "Spinnaker",
        "Syncopate",
        "Times New Roman",
        "Trebuchet MS",
        "Urbanist",
        "Vibes",
        "Wire One",
        "Zalando Sans Expanded"];

    /*React.useEffect(() => {
    }, [item.style['font-family']])*/

    const fontOption = fontArray.map((font: any) => {
        return <option value={font} style={{ fontFamily: font }} key={font} >{font}</option>
    });


    const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        let from = item.style['font-family'];
        if (selectedItem != null) { selectedItem.style.fontFamily = value; item.style['font-family'] = value; }

        handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, zoomValue);

        let action = createOneValueElementAction({
            target: "font-family",
            item: item,
            from: from,
            to: item.style['font-family'],
            context: { zoomValue, getSelectedItem }
        });

        history.add(action);

    };

    return (
        <select value={item.style['font-family']} name="fonts" id="font-select" onChange={selectChange} >
            {fontOption}
        </select >
    );
}

function FontPickerMobile(props: any) {

    const item = props.item;

    const { selectedItem, zoomValue, history, getSelectedItem } = useContext(PageContext);

    const fontArray = ["Abril Fatface",
        "Amatic SC",
        "Alfa Slab One",
        "Arial",
        "Arial Black",
        "Arimo",
        "Audiowide",
        "Bauhaus",
        "Baskerville",
        "Bebas Neue",
        "Bruno Ace",
        "Cabin Sketch",
        "Cinzel",
        "Comic Sans MS",
        "Courier",
        "Coolvetica",
        "Creepster",
        "DM Serif Text",
        "Edo",
        "Epilogue",
        "Exo",
        "Geist",
        "Georgia",
        "Gruppo",
        "Hachi Maru Pop",
        "Helvetica",
        "Homemade Apple",
        "IBM Plex Mono",
        "Impact",
        "Indie Flower",
        "Instrument Sans",
        "Kalnia",
        "Kodchasan",
        "Koulen",
        "Krona One",
        "Lexend Exa",
        "Limelight",
        "Londrina Shadow",
        "Michroma",
        "Monaco",
        "Monoton",
        "Montserrat",
        "Nothing You Could Do",
        "Open Sans",
        "Orbitron",
        "Oswald",
        "Outfit",
        "Palatino",
        "Patrick Hand SC",
        "Poiret One",
        "Poppins",
        "Questrial",
        "Raleway",
        "Reem Kufi",
        "Righteous",
        "Roboto",
        "Rubik Mono One",
        "Sanchez",
        "Shadows Into Light",
        "Sora",
        "Special Elite",
        "Spinnaker",
        "Syncopate",
        "Times New Roman",
        "Trebuchet MS",
        "Urbanist",
        "Vibes",
        "Wire One",
        "Zalando Sans Expanded"];

    const fontOption = fontArray.map((font: any) => {
        var isFont = selectedItem.style.fontFamily.includes(font);
        return <div className={'font-option' + (isFont ? ' active-font' : '')} style={{ fontFamily: font, flex: 'none', margin: '5px', padding: '5px' }} key={font} onClick={(e) => selectFont(e, font)} >{font}</div>
    });

    const elemFont = () => {
        return (
            <div className='font-mobile-container'>
                {fontOption}
            </div>
        )
    }



    const selectFont = (event: any, fontParam: any) => {
        //remove active class
        $('.font-option').removeClass('active-font');
        //active new
        event.target.className += " active-font";

        const value = fontParam;
        let from = item.style['font-family'];
        if (selectedItem != null) { selectedItem.style.fontFamily = value; item.style['font-family'] = value; }

        handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, zoomValue);

        let action = createOneValueElementAction({
            target: "font-family",
            item: item,
            from: from,
            to: item.style['font-family'],
            context: { zoomValue, getSelectedItem }
        });

        history.add(action);

    };

    return (
        <Popover content={elemFont()} placement="top" fill={true}>
            <Button className='' icon="font">Police</Button>
        </Popover>
    );
}

function Slider(props: any) {

    var fn = props.fn;
    var refSize = [props.refSize];
    var min = props.min;
    var max = props.max;

    const { isLandscape } = useMobileOrientation();

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                margin: "10px",
                alignItems: "center"
            }}
        >
            <Range
                step={1}
                min={min}
                max={max}
                values={refSize}
                onChange={(values) => fn(values)}
                renderTrack={({ props, children }) => (
                    <div
                        {...props}
                        style={{
                            ...props.style,
                            height: '4px',
                            width: (isDesktop || isTablet || (isMobile && isLandscape)) ? '90px' : '150px',
                            backgroundColor: '#000000'
                        }}
                    >
                        {children}
                    </div>
                )}
                renderThumb={({ props }) => (
                    <div
                        {...props}
                        style={{
                            ...props.style,
                            height: '18px',
                            width: '18px',
                            border: '1px solid #2B2827',
                            borderRadius: '50%',
                            backgroundColor: '#FFFFFF',
                        }}
                    />
                )} />
        </div>
    );
}

export default TextPicker;

